import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import Icon from 'dpl/common/components/Icon';
import SimpleMultiSelect from 'dpl/form/components/SimpleMultiSelect';
import TooltipWrapper from 'dpl/common/tooltip/components/TooltipWrapper';
import { resetParams } from 'dpl/actions/query_params';
import useSearchQueryFilter from 'dpl/breeder_search_results/hooks/useSearchQueryFilter';

function MultiSelectFilterLabel({ label, filterTooltipText }) {
  return (
    <span className="flex align-items-center">
      {label}
      {filterTooltipText && (
        <TooltipWrapper
          data-test-id="filter-tooltip"
          title={filterTooltipText}
          minWidth="250px"
          variant="light"
        >
          <Icon
            name="help-16"
            width="15"
            height="15"
            className="ml1 dark-gray"
          />
        </TooltipWrapper>
      )}
    </span>
  );
}

MultiSelectFilterLabel.propTypes = {
  label: PropTypes.string,
  filterTooltipText: PropTypes.string
};

MultiSelectFilterLabel.defaultProps = {
  filterTooltipText: null,
  label: ''
};

export default function MultiSelectFilter({
  filterTooltipText,
  filterParam,
  filterValues,
  groupedFilterValues,
  label
}) {
  const dispatch = useDispatch();
  const { searchQueryFilterValues, toggleFilter } =
    useSearchQueryFilter(filterParam);

  function handleAllFiltersClear() {
    dispatch(resetParams(filterParam, { hash: true }));
  }

  return (
    <SimpleMultiSelect
      availableTags={filterValues}
      groupedTags={groupedFilterValues}
      label={
        <MultiSelectFilterLabel
          label={label}
          filterTooltipText={filterTooltipText}
        />
      }
      onAllValuesClear={handleAllFiltersClear}
      onValueSelect={toggleFilter}
      onValueRemove={toggleFilter}
      selectedValues={searchQueryFilterValues}
    />
  );
}

MultiSelectFilter.propTypes = {
  // [{ title: 'Foo', value: 'foo }]
  filterValues: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ),
  // ['Standard', [{ title: 'Blue Merle', value: 7]]
  groupedFilterValues: PropTypes.arrayOf(PropTypes.array),
  filterTooltipText: PropTypes.string,
  filterParam: PropTypes.string.isRequired,
  label: PropTypes.string
};

MultiSelectFilter.defaultProps = {
  filterTooltipText: null,
  label: '',
  filterValues: null,
  groupedFilterValues: null
};
